<template>
  <MainWrapper>
    <div class="single-master-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="container-fluid no-p">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="mb-15">Новости</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mb-30">
                                    <Paginator :pages='pages' v-if="pages > 1" :current='page' v-on:change-page="(p) => page = p" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3" v-for="n in news" :key="n.id">
                                <News :title="n.title" :date="n.created_at" :views="213" :img="n.image" :id="n.id" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <Paginator :pages='pages' v-if="pages > 1" :current='page' v-on:change-page="(p) => page = p" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
    @import '../styles/main.core.vars.styl';

    .spec-categories
        padding: 20px 60px 30px 20px

    .spec-categories-header
        display: flex
        .spec-count
            margin: 0 0 0 auto
            color: $gray_text

    .spec-categories-single
        display: flex
        align-items: center
        >.icon
            margin-left: auto
            font-size: 16px
    
</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import moment from 'moment'
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import News from '@/components/News.vue';
    import Paginator from '@/components/Paginator.vue';

    import http from '@/methods/http.ts';

    @Component({
        components: {
            MainWrapper,
            Button,
            News,
            Paginator
        }
    })
    export default class NewsPage extends Vue {

        news = [];

        page = 1;
        pages = 0;

        @Watch('page', {deep: true, immediate: true})
        onPageChange() {
            this.getNews();
        }

        getNews() {
            http("news", "get", false, {
                page: this.page,
                limit: 8,
            }).then(
                r => {
                    this.news = r.data.results;
                    this.pages = Math.ceil(r.data.count / 10);
                }
            );
        }


    }
</script>